import Modal from '../modal/Modal';
import { Account } from '../../types/interfaces/account.interfaces';
import { BUTTON_CONSTANTS, ON_FARM_BILLING_CONSTANTS } from '../../constants/common';
import '../lock-unlock-account-modal/lockUnlockAccountModal.scss';

type OnFarmRemoveQuoteModalProps = {
  isOpen: boolean;
  width?: number;
  account?: Account;
  activeTankCount?: number | null;
  maxStandardTanks?: number | null;
  onClose: () => void;
  onConfirm: () => void;
};

const OnFarmRemoveQuoteModal = ({
  isOpen,
  width = 600,
  account,
  activeTankCount,
  maxStandardTanks,
  onClose,
  onConfirm,
}: OnFarmRemoveQuoteModalProps) => {
  const tooManyTanks = activeTankCount != null && maxStandardTanks != null && activeTankCount > maxStandardTanks;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={width} ignoreBackdrop>
      <div className="lock-unlock-account-modal">
        <div className="header">
          <h4>{ON_FARM_BILLING_CONSTANTS.REMOVE_CUSTOM_QUOTE}</h4>
        </div>
        <div className="body">
          <div className="body-content">
            <p>
              <b>{account?.name}</b>
            </p>
            <p>
              {tooManyTanks
                ? ON_FARM_BILLING_CONSTANTS.REMOVE_QUOTE_TOO_MANY_TANKS(activeTankCount, maxStandardTanks)
                : ON_FARM_BILLING_CONSTANTS.REMOVE_QUOTE_CONFIRM}
            </p>
          </div>
        </div>
        <div className="footer">
          {tooManyTanks ? (
            <button className="button blue inverted small" onClick={onClose}>
              {BUTTON_CONSTANTS.CLOSE}
            </button>
          ) : (
            <>
              <button className="button blue inverted small" onClick={onClose}>
                {BUTTON_CONSTANTS.CANCEL}
              </button>
              <button className="button red small" onClick={onConfirm}>
                {BUTTON_CONSTANTS.YES}
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default OnFarmRemoveQuoteModal;
